import { Component } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ActivReward from './ActivReward/';
import EMCVerificationPortalWithRouter from './EMC/';

class Main extends Component {
    render() {
        return (
            <div className="container">
                <section className="mt-4 mb-4">
                    <BrowserRouter basename="/web">
                        <Routes>
                            <Route path='/activ-reward' element={<ActivReward/>}></Route>
                            <Route path='/e-mc' element={<EMCVerificationPortalWithRouter/>}></Route>
                            <Route path='/e-mc/:reference_id' element={<EMCVerificationPortalWithRouter/>}></Route>
                        </Routes>
                    </BrowserRouter>
                </section>
            </div>
        )
    }
}

export default Main;
